<template>
    <div>
  <nav class="nav-extended rounded-lg blue">

    <div class="nav-wrapper">
        
        <router-link to="/" class="brand-logo">Comida Segura </router-link>
        <a href="#" data-trigger="mobile-demo" class="sidenav-trigger">
            <div>
    <b-button v-b-toggle.sidebar-right size="sm" variant="outline-primary" color="red">Menú</b-button>
    <b-sidebar id="sidebar-right" title="Opciones" right shadow>
       <div class="px-5 py-2">
        <p>
          <b-list-group>
         <b-list-group-item variant="info"><router-link to="/Registro" v-show="this.$localStorage.get('token')==null"><h5>Registro</h5></router-link></b-list-group-item>
         <b-list-group-item variant="info"><router-link to="/iniciarSesion" v-show="this.$localStorage.get('token')==null"><h5>Iniciar Sesión</h5></router-link></b-list-group-item>
         <b-list-group-item variant="info"><router-link to="/menuinicial" v-show="this.$localStorage.get('token')!=null"><h5>Herramientas</h5></router-link></b-list-group-item>
          
         <b-list-group-item variant="info" ><a href="#" @click="salir" v-show="this.$localStorage.get('token')!=null"><h5>Salir</h5></a></b-list-group-item>
          </b-list-group>   
        </p>
        
      </div>
    </b-sidebar>
  </div>
        </a>
         <ul id="nav-mobile" class="right hide-on-med-and-down">
         <li><router-link to="/Registro" v-show="this.$localStorage.get('token')==null">Registro</router-link></li>
         <li><router-link to="/iniciarSesion" v-show="this.$localStorage.get('token')==null">Iniciar Sesión</router-link></li>
         <li><router-link to="/menuinicial" v-show="this.$localStorage.get('token')!=null">Herramientas</router-link></li>
         <li ><a href="#" @click="salir" v-show="this.$localStorage.get('token')!=null">SALIR</a></li>
         </ul>
    </div>
    
    </nav> 
   </div>
</template>

<script>

import axios from 'axios'


export default {
    name:'Cabecera',
    
    methods:{
        salir(){
            
            const token = JSON.parse(this.$localStorage.get('token'))
            

            axios.get('https://micomidasegura.mx/comidaSegura/api/loginRegistro/salir.php?token='+ token)
            
.then(response=>{
        if (response.data=='success') {
          this.$localStorage.remove('token')            
            location.reload()
            //this.$router.push('/')
            //alert('fin de sesion'+this.$localStorage.remove('token'))
            
        }
})
        },
        
    }

}

</script>


// WEBPACK FOOTER //
// src/components/Cabecera.vue